exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main[data-v-078753dd] {\n  /*50 = navbar  */\n  /* min-height: calc(100vh - 50px); */\n  /* navbar已经fixed,不需要再减50 */\n  min-height: 100vh;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  background-color: #f8f8f8!important;\n}\n.fixed-header + .app-main[data-v-078753dd] {\n  /* padding-top: 50px; */\n  /* header 50px的高度 + 20px原本main内容的padding-top */\n  padding-top: 4.375rem;\n}", ""]);

// exports
